
<template>
    <div class="my-3 mx-2">
        <div class="d-flex align-items-center my-1">
            <div class="mx-2 h3">Products</div>
            <router-link to="/products/add">
                <button class="btn btn-sm border border-primary text-primary" v-if="permissions.ADD_CONTENT == 'Y'">
                    Add New Product
                </button>
            </router-link>
        </div>
        <AllElements category_id="7" editLink="products"></AllElements>
    </div>
</template>
<script>
import AllElements from "@/components/ElementComponents/AllElements";

export default {
    setup() { },
    components: {
        AllElements,
    },
    created() {
        this.permissions = JSON.parse(localStorage.getItem("permissions"));
    },
    data() {
        return {
            permissions: {},
        }
    }
};
</script>